export interface Category {
  name: string;
  slug: string;
  url: string;
  image: string;
}

export const categories: Category[] = [
  {
    name: "Scarpe",
    slug: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Pair%20of%20designer%20white%20leather%20sneakers%20on%20weathered%20wooden%20floor%20near%20window%2C%20morning%20sunlight%20casting%20long%20shadows%2C%20minimal%20composition%2C%20fresh%20organic%20texture%2C%20scandinavian%20interior%20aesthetic%2C%20soft%20warm%20neutral%20palette&width=800&height=600&seq=cat-shoes-v2&orientation=landscape"
  },
  {
    name: "Felpe/Maglioni",
    slug: "Hoodies/Sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Oversized%20cream%20knit%20sweater%20draped%20over%20a%20vintage%20rattan%20chair%2C%20afternoon%20light%20filtering%20through%20linen%20curtains%2C%20soft%20cozy%20atmosphere%2C%20textural%20contrast%20between%20wool%20and%20natural%20fibers%2C%20warm%20beige%20and%20ivory%20tones%2C%20editorial%20still%20life&width=800&height=600&seq=cat-hoodies-v2&orientation=landscape"
  },
  {
    name: "T-Shirt",
    slug: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20cotton%20striped%20t-shirt%20neatly%20folded%20on%20white%20marble%20surface%2C%20small%20potted%20succulent%20beside%20it%2C%20bright%20diffused%20daylight%20from%20above%2C%20clean%20minimal%20flat%20lay%2C%20soft%20shadows%2C%20contemporary%20boutique%20aesthetic&width=800&height=600&seq=cat-tshirts-v2&orientation=landscape"
  },
  {
    name: "Giacche",
    slug: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Olive%20green%20bomber%20jacket%20hanging%20on%20a%20minimal%20wooden%20hanger%20against%20a%20textured%20clay%20wall%2C%20side%20lighting%20creating%20dramatic%20fabric%20highlights%2C%20urban%20editorial%20style%2C%20earthy%20warm%20tones%2C%20industrial%20chic%20vibe&width=800&height=600&seq=cat-jackets-v2&orientation=landscape"
  },
  {
    name: "Pantaloni/Corti",
    slug: "Pants/Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Tailored%20linen%20trousers%20laid%20flat%20on%20light%20oak%20floorboards%2C%20afternoon%20sun%20creating%20warm%20geometric%20patterns%2C%20minimal%20overhead%20composition%2C%20natural%20textures%2C%20soft%20sand%20and%20cream%20color%20palette%2C%20editorial%20fashion%20flat%20lay&width=800&height=600&seq=cat-pants-v2&orientation=landscape"
  },
  {
    name: "Cappelli",
    slug: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Classic%20beige%20baseball%20cap%20resting%20on%20a%20stack%20of%20vintage%20books%2C%20golden%20hour%20sunlight%20through%20window%20blinds%2C%20warm%20retro%20aesthetic%2C%20dust%20motes%20in%20light%20beams%2C%20nostalgic%20editorial%20style%2C%20rich%20honey%20and%20cream%20tones&width=800&height=600&seq=cat-headwear-v2&orientation=landscape"
  },
  {
    name: "Set Completi",
    slug: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Coordinated%20two-piece%20linen%20outfit%20displayed%20on%20a%20minimal%20wooden%20mannequin%2C%20soft%20studio%20lighting%20from%20left%2C%20clean%20cream%20backdrop%2C%20boutique%20window%20display%20aesthetic%2C%20gentle%20fabric%20draping%2C%20warm%20neutral%20tones&width=800&height=600&seq=cat-sets-v2&orientation=landscape"
  },
  {
    name: "Intimo",
    slug: "underwear/underpants",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Soft%20cotton%20loungewear%20set%20folded%20on%20a%20fluffy%20white%20towel%2C%20spa-like%20setting%20with%20eucalyptus%20sprigs%2C%20gentle%20morning%20light%2C%20serene%20wellness%20aesthetic%2C%20clean%20white%20and%20sage%20green%20accents%2C%20premium%20comfort%20vibe&width=800&height=600&seq=cat-underwear-v2&orientation=landscape"
  },
  {
    name: "Maglie Sportive",
    slug: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Vintage%20style%20football%20jersey%20pinned%20on%20a%20cork%20board%2C%20soft%20spotlight%20illumination%2C%20sports%20memorabilia%20aesthetic%2C%20textured%20fabric%20details%20visible%2C%20warm%20retro%20lighting%2C%20brick%20wall%20background%2C%20nostalgic%20sports%20editorial&width=800&height=600&seq=cat-jersey-v2&orientation=landscape"
  },
  {
    name: "Accessori",
    slug: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Minimalist%20gold%20jewelry%20set%20scattered%20on%20raw%20silk%20fabric%2C%20soft%20directional%20light%20creating%20delicate%20sparkle%2C%20luxury%20editorial%20style%2C%20warm%20champagne%20and%20ivory%20palette%2C%20shallow%20depth%20of%20field%2C%20elegant%20refined%20composition&width=800&height=600&seq=cat-accessories-v2&orientation=landscape"
  },
  {
    name: "Borse",
    slug: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Structured%20cognac%20leather%20tote%20bag%20placed%20on%20a%20mid-century%20modern%20armchair%2C%20natural%20light%20from%20large%20window%2C%20sophisticated%20interior%20setting%2C%20rich%20warm%20brown%20and%20cream%20tones%2C%20editorial%20home%20decor%20aesthetic%2C%20quiet%20luxury%20vibe&width=800&height=600&seq=cat-bags-v2&orientation=landscape"
  },
  {
    name: "Cinture",
    slug: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Handcrafted%20braided%20leather%20belt%20coiled%20on%20a%20smooth%20concrete%20surface%2C%20harsh%20afternoon%20shadow%20creating%20graphic%20lines%2C%20minimal%20brutalist%20aesthetic%2C%20warm%20tan%20leather%20against%20cool%20gray%2C%20architectural%20composition%2C%20modern%20artisan%20style&width=800&height=600&seq=cat-belts-v2&orientation=landscape"
  },
  {
    name: "Profumi",
    slug: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Amber%20glass%20perfume%20bottle%20with%20delicate%20white%20flowers%20scattered%20around%2C%20soft%20backlight%20creating%20luminous%20glow%2C%20romantic%20editorial%20style%2C%20warm%20golden%20and%20blush%20tones%2C%20dreamy%20shallow%20depth%20of%20field%2C%20french%20perfumery%20aesthetic&width=800&height=600&seq=cat-perfumes-v2&orientation=landscape"
  },
  {
    name: "Altro",
    slug: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Eclectic%20curated%20collection%20of%20lifestyle%20accessories%20on%20a%20travertine%20coffee%20table%2C%20sunglasses%20watch%20wallet%20keychain%2C%20morning%20light%2C%20editorial%20flat%20lay%2C%20warm%20neutral%20palette%2C%20masculine%20refined%20aesthetic%2C%20modern%20gentleman%20style&width=800&height=600&seq=cat-other-v2&orientation=landscape"
  },
];